import { create, valueOf } from 'microstates';
import { textToElement } from './svg-utils';
import ColorState from '../states/color';
import FontState from '../states/font';

function extractColor({ svgElement, appState }) {
  /*
   * IE 11 doesn't support `.dataset` on a `<metadata>` tag in SVG
   */

  const data = svgElement.querySelector('#svg-data');
  const textColor = data ? data.getAttribute('data-color') : false;
  return textColor
    ? (() => {
      const [color] = valueOf(appState.textColors.filter(x => x.name.state === textColor).textColors);
      const colorState = create(ColorState, color);
      return appState.textColor.set(colorState);
    })()
    : appState;
}

function extractFontFace({ svgElement, appState }) {
  const data = svgElement.querySelector('#svg-data');
  const fontFamily = data ? data.getAttribute('data-font-family') : false;

  if (fontFamily) {
    const [fontFace] = valueOf(appState.fontFaces.filter(x => x.family.state === fontFamily).fontFaces);
    const fontState = create(FontState, fontFace);
    return appState.fontFace.set(fontState);
  }

  return appState;
}

function extractAlignment({ svgElement, appState }) {
  /*
   * IE 11 doesn't support `.dataset` on a `<metadata>` tag in SVG
   */
  const data = svgElement.querySelector('#svg-data');
  const alignment = data ? data.getAttribute('data-alignment') : false;
  return alignment
    ? appState.format.set(alignment)
    : appState;
}

function extractHasImage({ svgElement, appState, stores }) {
  /*
   * Handle the existing note. Since we aren't tracking if a note
   * has an image or not, we query the svg to see if there is one
   * present. if there is, trigger the `selectLayout` transition and
   * set the `photo` state.
   * If not, trigger `selectLayout` transition with 'text'.
   */
  const imageElement = svgElement.querySelectorAll('[data-note-id="photo"]')[0];

  return imageElement
    ? (() => {
      stores.photo.set(stores.$photo.photoSrc.set(imageElement.href.baseVal));
      return appState.selectLayout('photo');
    })()
    : appState.selectLayout('text');
}

export function stateFromSvg(svg, appState, stores) {
  const svgElement = textToElement(svg);

  appState = extractColor({ svgElement, appState });
  appState = extractAlignment({ svgElement, appState });
  appState = extractHasImage({ svgElement, appState, stores });
  appState = extractFontFace({ svgElement, appState });

  return appState;
}
